'use client';
import { Modal } from '../Modal/Modal';
import { Text } from '@/ui-components/atoms/Text/Text';
import { Tabs, type TabItem } from '@/ui-components/atoms/Layout/Tabs/Tabs';
import styles from './PopularChannelsModal.module.scss';
import { ReactNode, useRef, useState } from 'react';
import { ImageWrapper } from '@/shared-components/ImageWrapper/ImageWrapper';
// TODO: dinamically import this once migrated into de-sxm-www
import { FocusTrap } from 'focus-trap-react';
import useClickOutside from '@/hooks/useClickOutside';

interface ImageItem {
    content: ReactNode;
}

interface PopularChannelsModalProps {
    open: boolean;
    onClose: () => void;
    heading?: string;
    tabs: {
        title: string;
        description?: string;
        items: ImageItem[];
        mediaImage?: string;
    }[];
    dataLocalpagename?: string;
}

export const PopularChannelsModal = ({
    open,
    onClose,
    heading,
    tabs,
    dataLocalpagename,
}: PopularChannelsModalProps) => {
    const MODAL_CLICK_THROUGH_EXCEPTIONS_SELECTOR = '#onetrust-consent-sdk';
    const [focusPause, setFocusPause] = useState(false);
    const ref = useRef<HTMLDivElement>(null);
    useClickOutside(ref, {}, (state, event) => {
        if (event) {
            if (event.target) {
                const target = event.target as HTMLElement;
                const closest = target.closest(MODAL_CLICK_THROUGH_EXCEPTIONS_SELECTOR);

                setFocusPause(!!closest);
            }
        }
    });
    const renderedTabs: TabItem[] = tabs.map((tab) => ({
        title: tab.title,
        body: (
            <>
                {tab.description && (
                    <Text tag="div" variant="text-large" className={styles.tabDescription}>
                        {tab.description}
                    </Text>
                )}
                <div className={styles.channelGrid}>
                    {tab.items.map((item, i) => (
                        <div className={styles.channelItem} key={i}>
                            {item?.content}
                        </div>
                    ))}

                    {tab.mediaImage && (
                        <div className={styles.channelItem}>
                            {/* image size optimised based on container */}
                            <ImageWrapper src={tab.mediaImage} alt="" optimizedWidth={140} optimizedHeight={140} />
                        </div>
                    )}
                </div>
            </>
        ),
    }));

    return (
        <FocusTrap
            active={open}
            paused={focusPause}
            focusTrapOptions={{
                allowOutsideClick: true,
            }}
        >
            <Modal
                open={open}
                onClose={onClose}
                className={styles.modal}
                variant="medium"
                headline={heading}
                dataLocalpagename={dataLocalpagename}
            >
                <Tabs items={renderedTabs} />
            </Modal>
        </FocusTrap>
    );
};
